import CacheStorage from "../../../service/storage/CacheStorage";
import StorageKeys from "../../../const/StorageKeys";
import ApiUrls from "../../../service/api/ApiUrls";
import ApiService from "../../../service/api/ApiService";
import { navigate } from "../../../service/navigation/Navigation";
import UtilityHelper from "../../../service/utilities/UtilityHelper";
import ShowToast from "../../../widget/common/ui/Toast";

const GuestUserFormProvider = new (class GuestUserFormProvider {
  navigate = (url: any, params?: any | undefined) => {
    if (params !== undefined) {
      navigate(url, params);
    } else {
      navigate(url);
    }
  };

  // 1-feedback, 4-general
  setFormAPI = async (
    bId: string = "",
    formType: "1" | "4",
    params: {
      name: string;
      email: string;
      mobile_code_id: string;
      mobile_no: string;
      date: string;
      time: string;
      subject: string;
      description: string;
    }
  ): Promise<boolean> => {
    ApiUrls.init();

    const branchId: string = UtilityHelper.isNotEmpty(bId)
      ? bId
      : CacheStorage.getValue(StorageKeys.branch_id);

    const url: string = `${ApiUrls.baseUrl}arf/create_guest_general_feedback_request`;
    const body: any = {
      //company_id: companyId,
      branch_id: branchId,
      name: params.name,
      email: params.email,
      mobile_code_id: params.mobile_code_id,
      mobile_no: params.mobile_no,
      form_type: formType, //heading === "feedback_form" ? "1" : "4",
      date: params.date,
      time: params.time,
      subject: params.subject,
      description: params.description,
    };

    const response: any = await ApiService.postApi(url, body);
    if (response != null) {
      if (response["success"] === "1") {
        return true;
      } else {
        ShowToast.error(response["errorMessage"]);
      }
    }

    return false;
  };
})();

export default GuestUserFormProvider;
